var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "result-area" }, [
    _c("div", { staticClass: "result-area__wrapper" }, [
      _c(
        "div",
        { staticClass: "result-area__sidebar" },
        [
          _c("hotel-filters", {
            ref: "hotelfilters",
            attrs: {
              loadingOffers: _vm.loadingOffers,
              loadingFilters: _vm.loadingFilters,
              filterError: _vm.filterError
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "result-area__content" },
        [
          _c("result-bar", {
            ref: "resultbar",
            attrs: { "show-search": _vm.offer_error ? true : false }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "hotel-grid" },
            [
              _vm._l(_vm.hotelBlocks, function(hotelBlock, hotelKey) {
                return _c("hotel-block", {
                  key: hotelKey,
                  attrs: { hotel: hotelBlock }
                })
              }),
              _vm._v(" "),
              _vm.offer_error
                ? _c("div", { staticClass: "result-area__no-results" }, [
                    _c("h4", {
                      domProps: { textContent: _vm._s(_vm.offer_error.header) }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: { textContent: _vm._s(_vm.offer_error.text) }
                    }),
                    _vm._v(" "),
                    _vm.error_action == "change_traveldates"
                      ? _c("button", {
                          staticClass: "btn btn--positive",
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.btn_change_traveldates
                            )
                          },
                          on: { click: _vm.openCalendar }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.error_action == "reset_filters"
                      ? _c("button", {
                          staticClass: "btn btn--positive",
                          domProps: {
                            textContent: _vm._s(
                              _vm.translations.btn_reset_filters
                            )
                          },
                          on: { click: _vm.resetFilters }
                        })
                      : _vm._e()
                  ])
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          !_vm.offer_error
            ? _c("div", { staticClass: "result-area__content__buttons" }, [
                _vm.moreOffers
                  ? _c("button", {
                      staticClass: "btn btn--more-hotels",
                      domProps: {
                        textContent: _vm._s(_vm.translations.load_more_items)
                      },
                      on: {
                        click: function($event) {
                          _vm.$emit("loadmore")
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--alt btn--filters",
                    on: { click: _vm.gotoFilters }
                  },
                  [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(_vm.translations.filter_items_btn)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "svg",
                      {
                        staticClass: "icon-dropdown",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 395.65 223"
                        }
                      },
                      [
                        _c("path", {
                          staticStyle: { fill: "#fff" },
                          attrs: {
                            d:
                              "M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                          }
                        })
                      ]
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80a3ed14", { render: render, staticRenderFns: staticRenderFns })
  }
}